import React, { FC } from 'react'

import { FilterTag, FlexContainer, MiddleEllipsis, Tooltip } from '@avantstay/backoffice-core'

interface AddressRadiusTagProps {
  fullAddress?: string
  onClearFilter: VoidFunction
}

const MAX_TAG_LENGTH = 34
export const AddressRadiusTag: FC<AddressRadiusTagProps> = ({ fullAddress, onClearFilter }) => {
  const filterValueComponent = () =>
    fullAddress ? (
      <FlexContainer>
        <MiddleEllipsis data={fullAddress} tailLength={8} />
      </FlexContainer>
    ) : (
      <></>
    )

  const renderFilterTag = () => {
    if (fullAddress && fullAddress?.length > MAX_TAG_LENGTH) {
      return (
        <Tooltip content={fullAddress} placement="top">
          {filterValueComponent()}
        </Tooltip>
      )
    }

    return fullAddress ? filterValueComponent() : undefined
  }

  return (
    <FilterTag filterValue={renderFilterTag()} showFullSize={false} onClearFilter={onClearFilter} />
  )
}
